import { CurrencyEnum } from '../../types/enums';
import { Debt } from '../../types/accounts';

export const addDebt = (
  name: string,
  value: number,
  currency: CurrencyEnum
) => {
  const newDebt: Debt = { name, value, currency };
  return { type: 'DEBTS_NEW', debt: newDebt };
};
